import { parse } from 'cookie';

export const getAuthCookies = () => {
  return {
    es_ttl: parse(document.cookie).es_ttl,
  }
}

export const authorizationCheck = (status: number) => {
	if(status === 401 || status === 403) {
		throw new Error()
  }
}